import MantineFileManager from '@/components/MantineFileManager/MantineFileManager';
import { Stack } from '@mantine/core';
import { useDocumentTitle } from '@mantine/hooks';
import { useTranslate } from '@tolgee/react';
import { useParams } from 'react-router-dom';

const DrivePage = () => {
  const { t } = useTranslate();
  const { folderId } = useParams();

  useDocumentTitle(t('drive.title'));

  return (
    <Stack gap="md">
      <MantineFileManager
        rootFolderId={import.meta.env.VITE_DIRECTUS_DRIVE_ROOT_FOLDER}
        currentFolderIdFromUrl={folderId}
      />
    </Stack>
  );
};

export default DrivePage;
